import type { TourBasicInfoState } from '@/shared/api/types/tour-types'

/** Starting values of the tour basic-info section (also the baseline for "is the draft empty"). */
export const DEFAULT_TOUR_BASIC_INFO: TourBasicInfoState = {
  duration: 60,
  scopeType: 'tenantDestination',
  countryId: '',
  provinceId: '',
  tenantDestinationId: '',
  ticketLink: '',
  isFavorite: false,
}

/** A tour shorter than this (minutes) is rejected. */
export const MIN_TOUR_DURATION_MINUTES = 30

/** A route needs at least a start and an end point. */
export const MIN_TOUR_ROUTE_COORDINATES = 2

/** The ticket link must be an absolute http(s) URL. */
export const TICKET_LINK_PATTERN = /^https?:\/\/[^\s/$.?#].\S*$/i

/** Page size of the POI picker inside the tour form. */
export const TOUR_FORM_POI_PAGE_SIZE = 10

/** Steps of the tour form, in the order the user fills them (each later step depends on the earlier ones). */
export const TOUR_FORM_STEP_IDS = ['content', 'scope', 'route', 'media'] as const

/** i18n key + fallback label of each form step, shown in the step navigation. */
export const TOUR_FORM_STEP_LABELS: Record<
  (typeof TOUR_FORM_STEP_IDS)[number],
  { key: string; defaultValue: string }
> = {
  content: { key: 'tour.stepContent', defaultValue: 'Nội dung' },
  scope: { key: 'tour.stepScope', defaultValue: 'Phạm vi' },
  route: { key: 'tour.stepRoute', defaultValue: 'Tuyến điểm' },
  media: { key: 'tour.stepMedia', defaultValue: 'Ảnh' },
}
